import { icon } from "../../common/common";

export interface MenuItems {
  icon: any;
  title: string;
  callback: any;
  menuOnClick?: MenuItems[];
}
export const pinMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "keep" }),
    title: "Pin",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const unpinMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "keep_off" }),
    title: "Unpin",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const muteMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "notifications_off" }),
    title: "Mute",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const unmuteMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "notifications_active" }),
    title: "Unmute",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const deleteMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "delete" }),
    title: "Delete",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const blockMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "block" }),
    title: "Block",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const unblockMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "block", iconCustomClass: "rotate90" }),
    title: "Unblock",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const sharePostMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "video_library" }),
    title: "Share post",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const copyMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "content_copy" }),
    title: "Copy",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const replyMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "reply" }),
    title: "Reply",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};

export const optionsMenuItem = (callback: any, menuOnClick?: MenuItems[]) => {
  const item: MenuItems = {
    icon: icon({ iconName: "more_vert" }),
    title: "Options",
    callback: callback,
  };
  menuOnClick && (item.menuOnClick = menuOnClick);
  return item;
};
